// extracted by mini-css-extract-plugin
export default {"container":"ChoosePhotosList_container__e19Ht","item":"ChoosePhotosList_item__xqgKh"};